/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

function FormTimelineCardLink({
  cardTitle,
  cardId,
  boardId,
  onCardLinkClick,
}) {
  const canLink = cardId && boardId;
  const linkClass = canLink ? 'link-button-text' : '';
  const onClick = canLink ? () => onCardLinkClick?.({ cardId, boardId }) : undefined;
  return (
    <span className={linkClass} onClick={onClick}>
      {` ${cardTitle}`}
    </span>
  );
}

FormTimelineCardLink.propTypes = {
  cardTitle: PropTypes.string.isRequired,
  cardId: PropTypes.string,
  boardId: PropTypes.string,
  onCardLinkClick: PropTypes.func,
};

export default FormTimelineCardLink;
